import { TypographyT10, TypographyT9 } from '@picsart/design-system/foundation/typography';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      marginBottom: Spacings.s16,
    },

    titleSize: {
      ...TypographyT10,

      '@media screen and (max-width: 1112px)': {
        '&&': {
          ...TypographyT9,
        },
      },
    },
  },
  { name: 'TitleWithDefaultSize' },
);
